/**
 * Logger utility for environment-aware console output
 *
 * 本番環境ではconsole.errorのみを出力し、
 * console.log/warn/info/debugは抑止します。
 *
 * Usage:
 * - API: createLogger(env.ENVIRONMENT === 'production')
 * - Frontend/SDK: createLogger(import.meta.env.VITE_ENVIRONMENT === 'production')
 */
export const createLogger = (isProduction) => {
    const shouldLog = (level) => {
        if (!isProduction) {
            return true;
        }
        // 本番環境ではerrorのみ出力
        return level === 'error';
    };
    return {
        log: (...args) => {
            if (shouldLog('log')) {
                console.log(...args);
            }
        },
        warn: (...args) => {
            if (shouldLog('warn')) {
                console.warn(...args);
            }
        },
        error: (...args) => {
            if (shouldLog('error')) {
                console.error(...args);
            }
        },
        info: (...args) => {
            if (shouldLog('info')) {
                console.info(...args);
            }
        },
        debug: (...args) => {
            if (shouldLog('debug')) {
                console.debug(...args);
            }
        }
    };
};
